<template>
  <div class="keywords-modal">
    <div class="keywords-modal__header header-modal">
      <div class="header-modal__buttons">
        <BaseBtn
          @click="goToEdit"
          text="Редактировать"
          :blue="true"
        />
        <BaseBtn
          @clickBtn="deleteKeywords()"
          text="Удалить"
          :red="true"
        />
      </div>
      <input
        @input="searchKeywords"
        class="header-modal__search"
        type="search"
        placeholder="Поиск"
      />
    </div>
    <div class="keywords-modal__activities">
      <KeywordsModalActivities :activitiesId="categoryId"/>
    </div>
    </div>
    <ChangeTagsModal
      v-if="ChangeTagsModalVisible"
      :changeTags="false"
      :activitiesId="categoryId"
    />
    <div class="buttons">
    <BaseBtn
      blue
      text="Сохранить"
      @clickBtn="saveKeywords"
    />
    <BaseBtn
      blue
      text="Отменить"
      @clickBtn="cancelKeywords"
    />
  </div>
  <ConfirmDelete
    v-if="acceptDelete"
    @cancel="closeModal"
    @remove="removeKeywords"
  />
</template>

<script>
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import KeywordsModalActivities from '@/components/elements/KeywordsModalActivities.vue'
import BaseBtn from '@/components/ui/BaseBtn.vue'
import ChangeTagsModal from '@/components/modals/ChangeTagsModal.vue'
import ConfirmDelete from '@/components/modals/ConfirmDelete'

export default {
  name: 'KeywordsModal',
  components: {
    KeywordsModalActivities,
    BaseBtn,
    ChangeTagsModal,
    ConfirmDelete
  },
  props: {
    categoryId: {
      type: Number,
      default: null
    }
  },
  setup (props) {
    const store = useStore()

    const keywordsObj = computed(() => {
      return store.getters.getChangeKeywordsObj
    })

    const ChangeTagsModalVisible = computed(() => {
      return store.getters.getShowChangeTagsEditor
    })

    const acceptDelete = ref(false)

    const goToEdit = () => {
      store.commit('SetShowChangeTagsEditor', true)
    }

    const searchKeywords = (e) => {
      store.commit('SetKeywordsDataFilter', e.target.value.trim())
    }

    const deleteKeywords = () => {
      acceptDelete.value = true
    }

    const closeModal = () => {
      acceptDelete.value = false
    }

    const removeKeywords = () => {
      if (localStorage.activeProject === 'site') {
        const obj = {
          id: keywordsObj.value.Id,
          category: props.categoryId
        }
        store.dispatch('setDeleteKeywords', obj)
      } else if (localStorage.activeProject === 'education') {
        const obj = {
          id: keywordsObj.value.Id
        }
        store.dispatch('setDeleteKeywordsEducation', obj)
      }
      acceptDelete.value = false
    }

    const saveKeywords = () => {
      if (localStorage.activeProject === 'site') {
        if (props.categoryId === 3) {
          store.dispatch('setUpdateKeywords')
        } else if (props.categoryId === 2) {
          store.dispatch('setUpdateKeywordsNews')
        } else if (props.categoryId === 4) {
          store.dispatch('setUpdateKeywordsServices')
        }
      } else if (localStorage.activeProject === 'education') {
        store.dispatch('setUpdateKeywordsEducation')
      }
      store.commit('SetShowKeywordsEditor', false)
    }

    const cancelKeywords = () => {
      if (localStorage.activeProject === 'site') {
        if (props.categoryId === 3) {
          store.dispatch('setClearCacheInnerKeywords')
        } else if (props.categoryId === 2) {
          store.dispatch('setClearCacheInnerKeywordsNews')
        } else if (props.categoryId === 4) {
          store.dispatch('setClearCacheInnerKeywordsServices')
        }
      } else if (localStorage.activeProject === 'education') {
        store.dispatch('setClearCacheInnerKeywordsEducation')
      }
      store.commit('SetShowKeywordsEditor', false)
    }

    return {
      goToEdit,
      ChangeTagsModalVisible,
      searchKeywords,
      keywordsObj,
      deleteKeywords,
      saveKeywords,
      cancelKeywords,
      acceptDelete,
      closeModal,
      removeKeywords
    }
  }
}
</script>

<style lang="scss" scoped>
.keywords-modal {
  width: 1164px;

  &__header {
    display: flex;
    justify-content: flex-end;
  }

  .header-modal {
    &__buttons {
      display: flex;
      gap: 24px;
      padding-right: 64px;
    }

    &__search {
      width: 310px;
      height: 40px;
    }
  }

  &__activities {
    overflow-y: auto;
    height: 60vh;
  }
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 24px;
  padding-top: 16px
}
</style>
